import React from 'react'
import { Skeleton } from '@material-ui/lab'
import { useStyles } from './ViewsNewsSkeleton.styles'
import { Box } from '@material-ui/core'

const ViewsNewsSkeleton = () => {
  const classes = useStyles()

  return (
    <Box style={{ width: '100%' }}>
      <Skeleton variant="text" width="30%" height={24} animation="wave" />
      <Box className={classes.containerContent}>
        <Skeleton variant="text" className={classes.title} animation="wave" />
        <Skeleton variant="text" className={classes.writer} animation="wave" />
        <Box className={classes.imageContainer}>
          <Skeleton variant="rect" className={classes.image} animation="wave" />
          <Skeleton
            variant="text"
            className={classes.altImage}
            animation="wave"
          />
        </Box>
        <Box style={{ marginTop: '16px' }}>
          <Skeleton variant="text" width="100%" height={20} animation="wave" />
          <Skeleton variant="text" width="98%" height={20} animation="wave" />
          <Skeleton variant="text" width="95%" height={20} animation="wave" />
          <Skeleton variant="text" width="40%" height={20} animation="wave" />
          <br />
          <Skeleton variant="text" width="100%" height={20} animation="wave" />
          <Skeleton variant="text" width="97%" height={20} animation="wave" />
          <Skeleton variant="text" width="60%" height={20} animation="wave" />
        </Box>
        <Box style={{ marginTop: '16px' }}>
          <Skeleton
            variant="text"
            className={classes.tagTitle}
            animation="wave"
          />
          <Box className={classes.tagsContainer}>
            <Skeleton
              variant="rect"
              className={classes.tags}
              animation="wave"
            />
            <Skeleton
              variant="rect"
              className={classes.tags}
              animation="wave"
            />
            <Skeleton
              variant="rect"
              className={classes.tags}
              animation="wave"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ViewsNewsSkeleton
